import { render, staticRenderFns } from "./add-fines.vue?vue&type=template&id=b6bb2e06&"
import script from "./add-fines.vue?vue&type=script&lang=js&"
export * from "./add-fines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports